import React from 'react';
import { formatPhoneNumber } from 'react-phone-number-input';

import { ButtonWithLoadingState } from 'components/curo-components/common/Button';
import Modal from 'components/curo-components/common/Modal';
import ModalButtonsWrapper from 'components/curo-components/common/ModalButtonsWrapper';
import Button from 'components/digifi-wrappers/Button';
import { getContactInformationData } from 'handlers/curo-handlers/selectors';
import { useAppSelector } from 'hooks/reduxHooks';
import { CheckMarkIcon } from 'static/images';
import styled from 'types/AppTheme';

interface IConfirmContactInformationModalProps {
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const MODAL_TITLE = 'Please confirm before proceeding.';

const StyledDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  text-align: center;
  justify-content: center;
`;

const ConfirmContactInformationModal = ({
  onClose,
  onConfirm,
}: IConfirmContactInformationModalProps) => {
  const { borrowerEmail, borrowerPhone } = useAppSelector(getContactInformationData);

  return (
    <Modal
      title={MODAL_TITLE}
      onClose={onClose}
      actionElement={
        <ModalButtonsWrapper>
          <ButtonWithLoadingState kind="primary" size="form" onClick={onConfirm}>
            Confirm
          </ButtonWithLoadingState>
          <Button kind="secondary" size="form" onClick={onClose}>
            Edit
          </Button>
        </ModalButtonsWrapper>
      }
      description={
        <StyledDescriptionWrapper>
          <p>
            Please confirm that your cell phone number and email are correct. You will not be able
            to update them later in the process.
          </p>
          <div>
            <p>Email: {borrowerEmail}</p>
            <p>Cell Phone: {formatPhoneNumber(borrowerPhone)}</p>
          </div>
        </StyledDescriptionWrapper>
      }
      modalIcon={<CheckMarkIcon width={48} height={48} />}
    />
  );
};

export default ConfirmContactInformationModal;
